"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBaseUrl = void 0;
const root_1 = require("../root");
const enterprise_brand_enum_1 = require("./enums/enterprise-brand.enum");
const teliaProd = "https://telia.app.tendium.com";
const teliaStag = "https://telia-stag.app.tendium.com";
/**
 * Return base URL for a company
 * @param ownership
 * @param enterpriseBrand If company set brand is available
 * @param env
 * @returns BaseURL based on ownership, enterpriseBrand and env
 */
const getBaseUrl = (ownership, enterpriseBrand, env) => {
    const envIsProd = env === "prod";
    if (enterpriseBrand) {
        // If brand is provided, use it for the url
        switch (enterpriseBrand) {
            case enterprise_brand_enum_1.EnterpriseBrand.Telia:
                return envIsProd ? teliaProd : teliaStag;
            // Add more brands here as needed
        }
    }
    // No custom brand provided, falling back to ownership based URLs
    // Local gives stag urls
    switch (ownership) {
        case root_1.UserOwnership.Byggfakta: {
            return `https://${envIsProd ? "" : "staging."}public.byggfaktatender.com`;
        }
        case root_1.UserOwnership.Clira: {
            return `https://${envIsProd ? "" : "staging."}tender.clira.io`;
        }
        case root_1.UserOwnership.Tendium: {
            return `https://${envIsProd ? "" : "staging."}app.tendium.com`;
        }
        default: {
            // Default to Tendium
            return `https://${envIsProd ? "" : "staging."}app.tendium.com`;
        }
    }
};
exports.getBaseUrl = getBaseUrl;
